
import React from 'react';

function Auction() {
  return (
    <div>
      <h1>Auction Page</h1>
    </div>
  );
}

export default Auction;
